import {Component} from '@angular/core';
import { ParagraphComponent, SupplementHashAnchorsPipe } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-efa-paragraph',
    templateUrl: './efa-paragraph.component.html',
    imports: [AsyncPipe, SupplementHashAnchorsPipe]
})

export class EfaParagraphComponent extends ParagraphComponent {
}
